import { render, staticRenderFns } from "./loan_ms.vue?vue&type=template&id=0ce4ffe2&scoped=true"
import script from "./loan_ms.vue?vue&type=script&lang=js"
export * from "./loan_ms.vue?vue&type=script&lang=js"
import style0 from "./loan_ms.vue?vue&type=style&index=0&id=0ce4ffe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce4ffe2",
  null
  
)

export default component.exports